// shared/infrastructure/archivo.js  (lectura de archivos del navegador; la usan los hooks como dependencia inyectable)
import { BYTES_CABECERA } from '../domain/formatoImagen';

export const archivoRepository = {
  /** Primeros bytes de un File/Blob como Uint8Array; vacío si no se pudo leer. */
  async leerCabecera(file) {
    try {
      return new Uint8Array(await file.slice(0, BYTES_CABECERA).arrayBuffer());
    } catch (e) {
      return new Uint8Array(0);
    }
  },
};
